import { vservice } from '@niknevis/vue-modules'
import { PreferenceResourceModel } from '@/modules/preferences/models/preference-resource.model'
import collect from 'collect.js'
import { AdminPreferencesRoutes } from '@/modules/preferences/routes/admin-preferences.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import InertiaService from '@/modules/shared/helpers/http/services/inertia.service'
import { PreferencesCustomSortUpdateRequestModel } from '@/modules/preferences/models/preferences-request.model'


@vservice()
export class AdminPreferencesServices {
  constructor(
    private readonly inertiaService: InertiaService,
    private readonly routes: AdminPreferencesRoutes
  ) {
  }

  update(preference: PreferenceResourceModel[]) {
    return this.inertiaService
      .patch(this.routes.update(), {
        notifications: collect(preference).fromPairsOf('key', 'departments')
      })
  }

  customSortUpdate(data: PreferencesCustomSortUpdateRequestModel) {
    return Inertia.post(
      this.routes.customSorUpdate(),
      data
    )
  }
}

